import { ArtistExclusionList } from "@components/artist_exclusion_list/artist_exclusion_list";
import { Icon } from "@components/icon";
import { Loader } from "@components/loader/loader";
import { useFetchArtistExclusions } from "@hooks/use_fetch_artist_exclusions";
import React, { type FC } from "react";

const ArtistExclusionIndexPage: FC = () => {
  const { artistExclusions, loading } = useFetchArtistExclusions();

  if (loading) {
    return <Loader />;
  }
  if (!artistExclusions) {
    return null;
  }

  return (
    <div className="content">
      <header>
        <h1>Excluded Artists</h1>
        <div className="controls">
          <a
            href="/admin/exclusions/new"
            className="js-toggle-form add_new"
            title="Add new exclusion"
          >
            <Icon name="plus" />
          </a>
        </div>
      </header>

      <p>
        This page manages a list of artists who might be associated with 1890 on
        Mission Artists but for whatever reason are no longer in the building or
        should not be on the 1890 site.
      </p>
      <p>
        This list represents names or partial names which we match against the
        artist names we have and if there is a match, we will not show them, on
        the site.
      </p>
      <p>
        e.g. If you enter an exclusion here with &quot;roger&quot;, &quot;Mr
        Rogers&quot; and &quot;Roger Moore&quot; artists would both be excluded.
        Make the pattern as long as needed to uniquely identify the artist.
      </p>
      <ArtistExclusionList artistExclusions={artistExclusions} />
    </div>
  );
};

export { ArtistExclusionIndexPage };
